import SeatInfo, { SeatInfoProps } from './SeatInfo';

export type { SeatInfoProps };
export default SeatInfo;
